import { v4 as uuidv4 } from "uuid";
import { IMucThuSinhVienTab } from "../../../model/request/muc-thu/IMucThuSinhVienTab";
import { IMucThuSinhVienActionTypes } from "../../action-types/muc-thu/IMucThuSinhVienActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IMucThuSinhVienReducer } from "../../reducer-model/muc-thu/IMucThuSinhVienReducer";

const taoTabTrong = (): IMucThuSinhVienTab => ({
  id: uuidv4(),
  title: "Chưa chọn sinh viên",
  mucThuKhacs: [],
  selectedIds: [],
  status: eReducerStatusBase.is_not_initialization,
  phan: "khoan-khac",
  xemTatCaKy: false,
  hocKy: 0,
  namHoc: "",
});

const tabDau = taoTabTrong();

const iniState: IMucThuSinhVienReducer = {
  selectedId: tabDau.id,
  tabs: [tabDau],
  dangXuLyTabIds: [],
  processId: "",
  isShowProcessing: false,
};

/** Sửa đúng một tab, giữ nguyên các tab còn lại. */
const suaTab = (
  state: IMucThuSinhVienReducer,
  id: string,
  sua: (tab: IMucThuSinhVienTab) => IMucThuSinhVienTab,
): IMucThuSinhVienReducer => ({
  ...state,
  tabs: state.tabs.map((t) => (t.id === id ? sua(t) : t)),
});

export const mucThuSinhVienReducer = (
  state: IMucThuSinhVienReducer = iniState,
  action: IMucThuSinhVienActionTypes,
): IMucThuSinhVienReducer => {
  switch (action.type) {
    case "MUC_THU_SINH_VIEN_ADD_NEW_TAB": {
      // Em đã mở rồi thì nhảy về tab cũ, không mở trùng.
      const daCo = action.payload
        ? state.tabs.find((g) => g.sinhVien?.id_sv === action.payload?.id_sv)
        : undefined;
      if (daCo) return { ...state, selectedId: daCo.id };
      const tabMoi: IMucThuSinhVienTab = {
        ...taoTabTrong(),
        title: action.payload?.ho_ten ?? "Chưa chọn sinh viên",
        sinhVien: action.payload,
      };
      return {
        ...state,
        selectedId: tabMoi.id,
        tabs: [...state.tabs, tabMoi],
      };
    }

    case "MUC_THU_SINH_VIEN_REMOVE_TAB": {
      const conLai = state.tabs.filter((t) => t.id !== action.payload);
      // Đóng hết thì mở sẵn một tab trống để người dùng có chỗ chọn em tiếp theo.
      const tabs = conLai.length > 0 ? conLai : [taoTabTrong()];
      const selectedId =
        state.selectedId === action.payload
          ? tabs[tabs.length - 1].id
          : state.selectedId;
      return { ...state, tabs, selectedId };
    }

    case "MUC_THU_SINH_VIEN_CHANGE_SELECTED_TAB":
      return { ...state, selectedId: action.payload };

    case "MUC_THU_SINH_VIEN_CHON_SINH_VIEN": {
      // Em này đang mở ở tab khác → chuyển sang tab đó thay vì mở trùng.
      const daCo = state.tabs.find(
        (g) =>
          g.id !== action.payload.id &&
          g.sinhVien?.id_sv === action.payload.data.id_sv,
      );
      if (daCo) return { ...state, selectedId: daCo.id };
      return suaTab(state, action.payload.id, (t) => ({
        ...t,
        title: action.payload.data.ho_ten ?? "Chưa chọn sinh viên",
        sinhVien: action.payload.data,
        mucThuKhacs: [],
        selectedIds: [],
        status: eReducerStatusBase.is_not_initialization,
      }));
    }

    case "MUC_THU_SINH_VIEN_UPDATE_TAB_DATA":
      return suaTab(state, action.payload.id, () => action.payload);

    case "MUC_THU_SINH_VIEN_CHANGE_PHAN":
      return suaTab(state, action.payload.id, (t) => ({
        ...t,
        phan: action.payload.data,
      }));

    case "MUC_THU_SINH_VIEN_CHANGE_XEM_TAT_CA_KY":
      return suaTab(state, action.payload.id, (t) => ({
        ...t,
        xemTatCaKy: action.payload.data,
      }));

    case "MUC_THU_SINH_VIEN_CHANGE_SELECTED_IDS":
      return suaTab(state, action.payload.id, (t) => ({
        ...t,
        selectedIds: action.payload.data,
      }));

    case "MUC_THU_SINH_VIEN_LOAD_KHOAN_THU_START":
      return suaTab(state, action.payload.id, (t) => ({
        ...t,
        status: eReducerStatusBase.is_loading,
        hocKy: action.payload.request.hoc_ky,
        namHoc: action.payload.request.nam_hoc,
      }));

    case "MUC_THU_SINH_VIEN_LOAD_KHOAN_THU_SUCCESS":
      return suaTab(state, action.payload.id, (t) => ({
        ...t,
        status: eReducerStatusBase.is_completed,
        mucThuKhacs: action.payload.data ?? [],
        // Bỏ chọn những khoản không còn trong danh sách vừa nạp.
        selectedIds: t.selectedIds.filter((id) =>
          (action.payload.data ?? []).some((m) => m.id === id),
        ),
      }));

    case "MUC_THU_SINH_VIEN_LOAD_KHOAN_THU_ERROR":
      return suaTab(state, action.payload.id, (t) => ({
        ...t,
        status: eReducerStatusBase.is_completed,
      }));

    case "MUC_THU_SINH_VIEN_CHANGE_DANG_XU_LY":
      return {
        ...state,
        dangXuLyTabIds: action.payload.data
          ? [...state.dangXuLyTabIds, action.payload.id]
          : state.dangXuLyTabIds.filter((x) => x !== action.payload.id),
      };

    case "MUC_THU_SINH_VIEN_OPEN_PROCESSING_MODAL":
      return { ...state, processId: action.payload, isShowProcessing: true };

    case "MUC_THU_SINH_VIEN_CLOSE_PROCESSING_MODAL":
      return { ...state, processId: "", isShowProcessing: false };

    default:
      return state;
  }
};
